import { ButtonPage } from "./page-button";
import { PageRoot } from "./page-root";
import { PageHeader } from "./page-header";
import { PageSearch } from "./page-search";
import { ClientHeader } from "./system-header";
import { PageError } from "./page-error";
import { LoaderDSC } from "./page-loader";
import { NavBar } from "./page-navbar";
import { HeaderAux } from "./page-header-aux";

export const Page = {
  Root: PageRoot,
  CHeader: ClientHeader,
  Button: ButtonPage,
  Header: PageHeader,
  HeaderAux: HeaderAux,
  Search: PageSearch,
  Error: PageError,
  Loader: LoaderDSC,
  NavBar: NavBar,
};
